export const JOURNAL_DB_NAME = 'journal';
export const JOURNAL_PAGE_SIZE = 20;
